export class FilterModel<T>{
    private _filterOBject: Partial<T>;
    constructor(filterModel: Partial<T>) {
        this._filterOBject = filterModel
    }
    public generateFilterFromModel = (): string => {
        return `${encodeURIComponent(this.prepareJsonForFiltering(JSON.stringify(this._filterOBject)))}`;
    }
    private prepareJsonForFiltering = (jsonString: string): string => {
        let purified = jsonString
            .replaceAll("\"", "")
            .replaceAll("{", "")
            .replaceAll(":", "=")
            .replaceAll(",", "")
            .replaceAll("}", "")
            ;
        return purified;
    }
}
export class PaginationRequest {
    Page?: number;
    PageSize?: number;
    SortBy?: string;
    IsSortAscending?: boolean;
    Filter?: string;
}

export class FilterRequest<T> {

    private pagRequest: PaginationRequest;
    private filter: FilterModel<T>;
    constructor(paginationRequest: PaginationRequest, filter: FilterModel<T>) {
        this.pagRequest = paginationRequest;
        this.filter = filter;
    }
    public GenerateQueryFilter = (): string => {
        this.pagRequest.Filter = this.filter.generateFilterFromModel();

        const value = this.prepareJsonForFiltering(JSON.stringify(this.pagRequest));
        return `?${value}`;
    }

    private prepareJsonForFiltering = (json: string): string => {
        let purified = json
            .replaceAll("\"", "")
            .replaceAll("{", "")
            .replaceAll("}", "")
            .replaceAll(":", "=")
            .replaceAll(",", "&")
            ;
        return purified;
    }
}
